"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albosaggia": {
    "e56c6296": [{
      "hkey": "a69eadb9",
      "slug": "albosaggia",
      "name": "Albosaggia",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "a69eadb9",
      "slug": "albosaggia",
      "name": "Albosaggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3d1e9b05": [{
      "hkey": "8f84e0cd",
      "slug": "torchione-moia",
      "name": "Torchione-Moia",
      "primary": true,
      "skipSearch": false
    }],
    "moia": [{
      "hkey": "8f84e0cd",
      "slug": "torchione-moia",
      "name": "Torchione-Moia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "albosaggia"
    }],
    "b5afcae3": [{
      "hkey": "e42241bf",
      "slug": "albosaggia",
      "name": "Albosaggia",
      "primary": true,
      "skipSearch": false
    }],
    "porto": [{
      "hkey": "e42241bf",
      "slug": "albosaggia",
      "name": "Albosaggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23da9617": [{
      "hkey": "8f84e0cd",
      "slug": "torchione-moia",
      "name": "Torchione-Moia",
      "primary": true,
      "skipSearch": false
    }],
    "torchione": [{
      "hkey": "8f84e0cd",
      "slug": "torchione-moia",
      "name": "Torchione-Moia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "albosaggia"
    }]
  }
};
exports["default"] = _default;